/**
 * 瓦斯桶公斤數圖片 — 全站統一使用 kiosk 的瓦斯桶照片（5、10、16、20、50 公斤各一圖）。
 * 非標準公斤數 fallback 用通用圖。
 */
import icon5KG from "@screen/Kiosk/icon/5KG_icon.png";
import icon10KG from "@screen/Kiosk/icon/10KG_icon.png";
import icon16KG from "@screen/Kiosk/icon/16KG_icon.png";
import icon20KG from "@screen/Kiosk/icon/20KG_icon.png";
import icon50KG from "@screen/Kiosk/icon/50KG_icon.png";

const GAS_IMAGES: Record<number, string> = {
  5: icon5KG,
  10: icon10KG,
  16: icon16KG,
  20: icon20KG,
  50: icon50KG,
};

const DEFAULT_IMG = require("@styles/images/quickorder/gas-default.png");

export function getGasImageByKg(weight: string | number): string {
  const kg = typeof weight === "string" ? parseInt(weight, 10) : weight;
  if (Number.isNaN(kg) || !(kg in GAS_IMAGES)) return DEFAULT_IMG;
  return GAS_IMAGES[kg];
}
